class facetSorting extends HTMLElement {
    constructor() {
      super();
  
      this.sortingMain = this.querySelector('[js-sorting-wrap]');
      this.sortingHeader = this.querySelector('[js-sorting-header]');
      this.sortingSelectedValue = this.querySelector('[js-sorting-selected-value]');
      this.sortingOptionValues = this.querySelectorAll('[js-sorting-option]');
      this.sortingSelect = this.querySelector('select');
      this.facetForm = this.closest('form');
  
      this.toggleSorting = this.toggleSorting.bind(this);
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
    }
  
    connectedCallback() {
      this.sortingHeader.addEventListener('click', this.toggleSorting);
      this.sortingOptionValues.forEach(option => {
        option.addEventListener('click', this.handleOptionClick);
      });
      document.addEventListener('click', this.closeOnOutsideClick);
    }
  
    toggleSorting(event) {
      event.stopPropagation();
  
      const isActive = this.sortingMain.classList.contains('active');
      document.querySelectorAll('[js-sorting-wrap]').forEach((wrap) => wrap.classList.remove('active'));
  
      if (!isActive) {
        this.sortingMain.classList.add('active');
      } else {
        this.sortingMain.classList.remove('active'); 
      }
    }
  
    handleOptionClick(event) {
      event.stopPropagation();
  
      const selectedValue = event.target.textContent.trim();
      const selectedOptionValue = event.target.dataset.value;
  
      this.sortingSelectedValue.textContent = selectedValue;
  
      if (this.sortingSelect) {
        const optionToSelect = this.sortingSelect.querySelector(`option[value="${selectedOptionValue}"]`);
        if (optionToSelect) {
          optionToSelect.selected = true;
  
          this.facetForm.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
  
      this.sortingMain.classList.remove('active');
    }
  
    closeOnOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.sortingMain.classList.remove('active');
      }
    }
  }
  
  customElements.define('facet-sorting', facetSorting);
  